// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cM8kjrILs4k1m8 {
  display: grid;
  grid-template-columns: 1fr 77px;
  align-items: center;
  margin-top: var(--ds-space-150, 12px);
  gap: var(--ds-space-300, 22px);
}
.s8h3shuImcnDWC {
  grid-column: span 2;
}
`, ""]);
// Exports
export var inboxPositionSelector = `cM8kjrILs4k1m8`;
export var button = `s8h3shuImcnDWC`;
export default ___CSS_LOADER_EXPORT___;
